import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import SearchContentMedia from '../../Services/Queries/SearchContentMedia'
import ImageUpload from './ImageUpload'
import ReactCrop from 'react-image-crop'
import Toast from 'react-bootstrap/Toast'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Gallery } from "react-grid-gallery";

class SearchMediaLibrary extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			modalVisible: false,
			searchQuery: '',
			from: 0,
			total: 0,
			limit: 50,
			ContentMediaList: [],
			contentGallery: [],
			previousRenderedListLength: null,
			src: '',
			uploadFromLibrary: false,
			imageObj: {},
			selectedImages: [],
			mediaValidationModalVisible: false,
			// isUploaded: false,
			crop: {
				unit: '%',
				width: 30,
				aspect: this.props.circularCrop ? 1 : 16 / 9,
			},
			croppedImageUrl: '',
			croppedImage: '',


		}
	}
	openSearchMediaModal = () => {
		const { modalVisible, contentDetails } = this.state
		this.setState({ modalVisible: true })
	}
	closeSearchMediaModal = () => {
		this.setState({
			modalVisible: false,
			searchQuery: '',
			from: 0,
			total: 0,
			limit: 50,
			ContentMediaList: [],
			previousRenderedListLength: null,
			contentGallery: [],
			// selectedImages: [],

		})
	}

	onChangeSearch = (searchQuery) => {
		this.setState({ searchQuery: searchQuery })
	}
	clearSearch = () => {
		this.setState({
			searchQuery: '',
			from: 0,
			total: 0,
			limit: 50,
			ContentMediaList: [],
			previousRenderedListLength: null,
			contentGallery: [],

		})
	}
	searchContentMedia = async () => {
		const { searchQuery, limit } = this.state
		const input = {
			from: this.state.from,
			limit: limit,
			search: searchQuery
		}
		console.log(input, "input====================")
		const MediaList = await SearchContentMedia(input)
		console.log(MediaList, "=============searchContentMedia")
		let gallery = []
		{
			MediaList.items &&
				MediaList.items.map((row, index) =>
					this.handleMediaGallery(row, index, gallery)

				)
		}
		this.setState({
			ContentMediaList: MediaList.items,
			total: MediaList.total,
			previousRenderedListLength: MediaList.items.length,
			contentGallery: gallery

		})
	}
	handleMediaGallery = (row, index, gallery) => {

		let galleryObj = {}
		galleryObj.src = row.image
		galleryObj.isSelected = false
		gallery[index] = galleryObj
		return gallery
	}
	renderContentMediaList = (mediaList) => {
		const { total, ContentMediaList, previousRenderedListLength, contentGallery } = this.state

		return (
			<div class='Media'>
				<div>
					<div className="p-t-1 p-b-1">
						{/* <button onClick={handleSelectAllClick}>
                            {hasSelected ? "Clear selection" : "Select all"}
                        </button> */}
					</div>
					<Gallery images={contentGallery} onClick={(index, image) => this.handleSelect(index, image)} />
				</div>

				{previousRenderedListLength < total ? (
					<Button
						style={{
							fontSize: 10,
							padding: 5,
						}}
						onClick={() => this.getNextMedia(previousRenderedListLength)}
					>
						Load More
					</Button>
				) : null
				}
				<div>
					<Button
						style={{
							marginLeft: 1000,
						}}
						onClick={() => this.closeSearchMediaModal()}
					>
						Ok
					</Button>
				</div>


			</div>
		)
	}

	handleSelect = (index, image) => {

		const { contentGallery, ContentMediaList, src, uploadFromLibrary, selectedImages, mediaValidationModalVisible } = this.state
		const { selectedMedia } = this.props
		const imageSelectedFromGallery = ContentMediaList[index]

		let images = [], finalImages = [], modalVisible
		const selectedMediaImages = (selectedMedia && selectedMedia !== [] && selectedMedia.length > 0) ? selectedMedia : selectedImages
		const imageObj = {
			imageValue: imageSelectedFromGallery.image,
			key: imageSelectedFromGallery.SK,
			copyRight: (imageSelectedFromGallery.copyRightText && imageSelectedFromGallery.copyRightText != '') ? true : false,
			copyRightText: imageSelectedFromGallery.copyRightText ? imageSelectedFromGallery.copyRightText : '',
			shareImage: imageSelectedFromGallery.shareImage ? imageSelectedFromGallery.shareImage : false,
			isUploaded: true,
			isCropped: false,
		}
		images.push(imageObj)
		if (selectedMediaImages.length < 10) {
			contentGallery[index].isSelected = true
			finalImages = [...selectedMediaImages, ...images]
			modalVisible = false
			this.props.pushImageObj(imageObj, uploadFromLibrary)
			toast.success('Image Uploaded Successfully', this.toastStyle)
		} else {
			finalImages = selectedMediaImages
			modalVisible = true
		}
		this.setState({
			src: image,
			uploadFromLibrary: true,
			imageObj: imageObj,
			selectedImages: finalImages,
			mediaValidationModalVisible: modalVisible,
			contentGallery: contentGallery

		})
	}


	getNextMedia = async (previousListLength) => {
		const { searchQuery, limit } = this.state
		const nextInput = {
			from: previousListLength,
			limit: previousListLength + limit,
			search: searchQuery,
		}
		console.log(nextInput, "============nextInput")
		const nextMediaList = await SearchContentMedia(nextInput)
		console.log(nextMediaList.items.length, nextMediaList.items, "==============nextMediaList")
		const finalContentMediaList = [...this.state.ContentMediaList, ...nextMediaList.items]
		let finalGallery = []
		{
			finalContentMediaList &&
				finalContentMediaList.map((row, index) =>
					this.handleMediaGallery(row, index, finalGallery)

				)
		}
		this.setState({
			ContentMediaList: finalContentMediaList,
			previousRenderedListLength: nextMediaList.items.length,
			contentGallery: finalGallery
		})
	}
	renderSearchMediaModal = () => {
		const {
			modalVisible,
			searchQuery,
			ContentMediaList,
			mediaValidationModalVisible
		}
			= this.state

		return (
			<section>
				<ToastContainer
					position='top-right'
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
				<div>
					<Modal show={mediaValidationModalVisible} onHide={() => this.setState({ mediaValidationModalVisible: false })}>
						<Modal.Body>Multi Select Upto 10 Images</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.handleModal()}>Ok</Button>
						</Modal.Footer>
					</Modal>
					<Modal show={modalVisible} onHide={() => this.closeSearchMediaModal()} size='xl'>
						<Modal.Body>
							<div >
								<div class='row col-md-5' style={{ display: 'inline' }}>
									<input
										style={{ maxWidth: '350px' }}
										type='text'
										onChange={(e) => {
											this.onChangeSearch(e.target.value)
										}}
										value={this.state.searchQuery}
										placeholder='Enter minimum 3 letters  to search media'
									></input>
								</div>
								<Button
									disabled={this.state.searchQuery && this.state.searchQuery.length >= 3 ? false : true}
									style={{ marginRight: 10, marginLeft: 10 }}
									onClick={() => {
										this.searchContentMedia()
									}}
								>
									Search
								</Button>
								<Button
									disabled={this.state.searchQuery ? false : true}
									// style={{ marginRight: 10 }}
									onClick={() => {
										this.clearSearch()
									}}
								>
									Clear
								</Button>
								{ContentMediaList && ContentMediaList.length > 0 ?
									(this.renderContentMediaList(ContentMediaList)) :

									(<div>
										No Media Found
									</div>)
								}


							</div>
						</Modal.Body >

					</Modal >
				</div >
			</section>
		)
	}

	handleModal = () => {
		const { contentGallery } = this.state
		this.setState({ mediaValidationModalVisible: false })
	}

	render() {
		// const { cropImage, selectedImages, croppedImageUrl, uploadFromLibrary, mediaValidationModalVisible } = this.state
		return (
			<div class='row'>
				{this.renderSearchMediaModal()}

				<div class='col-md-4'>
					<ImageUpload
						selectedContentType={this.props.selectedContentType}
						shortByteTemplateType={this.props.shortByteTemplateType}
						pushImageObj={this.props.pushImageObj}
						setFeaturedImageId={this.props.setFeaturedImageId}
						multiImages={true}
						circularCrop={false}
					/>
				</div>
				<div class='col-md-6'>
					<Button
						onClick={() => {
							this.openSearchMediaModal()
						}}
					>
						Media Library
					</Button>
				</div>
			</div >



		)
	}
}

export default SearchMediaLibrary